import React from 'react';
import PropTypes from 'prop-types';
import Panel from '@adsk/alloy-react-panel';
import {
  COMPONENT_VARIANTS,
  userSharedProps,
} from '@adsk/acs-admin-ui-components-helpers';
import { useCreateAccountCompanyValidation } from '@adsk/acs-admin-ui-components-hooks';
import MemberInfo from './layout/MemberInfo';
import EditableMemberInfo from './layout/EditableMemberInfo';

import { panelBodyStyle } from './styles';

const MemberProfilePanel = ({
  children,
  companies,
  companySearchInput,
  companyCreateError,
  isEmsAccount,
  isFetchingCompanies,
  isFetchingRoles,
  onChangeCompanyInput,
  onChangeRoleInput,
  onCompanyChange,
  onCreateCompany,
  onRoleChange,
  optionsMenu,
  roles,
  roleSearchInput,
  selectedCompany,
  selectedRole,
  user,
  variant,
  ...rest
}) => {
  const canCreateCompanies = useCreateAccountCompanyValidation();

  const customHeader = ({ onClose }) => {
    const { id, name, email, imageUrl, phone, status } = user;
    return (
      <MemberInfo
        email={email}
        imageUrl={imageUrl}
        isEmsAccount={isEmsAccount}
        memberId={id}
        name={name}
        onClose={onClose}
        optionsMenu={optionsMenu}
        phone={phone}
        status={status}
        variant={variant}
      />
    );
  };

  return (
    <Panel {...rest} renderHeader={customHeader}>
      <Panel.Body style={panelBodyStyle}>
        <EditableMemberInfo
          canCreateCompanies={canCreateCompanies}
          companies={companies}
          companySearchInput={companySearchInput}
          companyCreateError={companyCreateError}
          isEmsAccount={isEmsAccount}
          isFetchingCompanies={isFetchingCompanies}
          isFetchingRoles={isFetchingRoles}
          onChangeCompanyInput={onChangeCompanyInput}
          onChangeRoleInput={onChangeRoleInput}
          onCompanyChange={onCompanyChange}
          onCreateCompany={onCreateCompany}
          onRoleChange={onRoleChange}
          roles={roles}
          roleSearchInput={roleSearchInput}
          selectedCompany={selectedCompany}
          selectedRole={selectedRole}
          variant={variant}
        />
        {children}
      </Panel.Body>
    </Panel>
  );
};

MemberProfilePanel.propTypes = {
  /** Hides information about Phone Number for EMS account users */
  isEmsAccount: PropTypes.bool,
  /** Project member data to display in the modal */
  user: PropTypes.shape(userSharedProps),
  /** Indicates if account level or project level member profile */
  variant: PropTypes.oneOf(Object.values(COMPONENT_VARIANTS)),
  /** Inherit all Panel component proptypes */
  ...Panel.propTypes,
};

MemberProfilePanel.defaultProps = {
  isEmsAccount: false,
  variant: COMPONENT_VARIANTS.PROJECT,
  user: {},
};

export default MemberProfilePanel;
